export enum WidgetNamesForErrorLogs {
  hotelCard = 'hotel card',
  multipleHotels = 'multiple hotels',
  multipleHotelsWithSearch = 'multiple hotels with search',
  multipleHotelsWithBanner = 'multiple hotels with banner'
}

export const initCustomErrorListener = (widgetName: string) => {
  window.addEventListener('error', error => {
    console.error(`Vio ${widgetName} widget error:`, error.message, error)
    error.preventDefault()
  })
}

export const handleError = (error: unknown, widgetName: string) => {
  const message = error instanceof Error ? error.message : 'Unknown error.'
  console.error(`Vio ${widgetName} widget init error:`, message, '\n', error)
}
